import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isCrawler } from 'helpers/authentication';
import AdKaoraBanner, { AdSlot } from 'ui/design-base/AdKaoraBanner';
import ClubBaseStatistics from 'ui/design-base/ClubBaseStatistics';
import ClubBasicInfo from 'ui/design-base/ClubBasicInfo';
import ClubHeader from 'ui/design-base/ClubHeader';
import ClubMembers from 'ui/design-base/ClubMembers';
import ClubRecentCompetitions from 'ui/design-base/ClubRecentCompetitions';
import ErrorBox from 'ui/design-base/ErrorBox';
import Page from 'ui/design-base/Page';
import { fetchClubProfile } from 'store/clubProfile/clubProfileSlice';
import { useAppDispatch, useAppSelector } from 'store/store';

export const ClubPage = () => {
  const { id } = useParams<string>();
  const dispatch = useAppDispatch();
  const { club, loading, error } = useAppSelector((state) => state.clubProfile);

  useEffect(() => {
    dispatch(fetchClubProfile(id));
  }, [id, dispatch]);

  const getPageDescription = () => `Pagina del circolo: ${club?.name} - regione: ${club?.region} - provincia: ${
    club?.province
  } - ${club?.legal_address} - ${club?.fields_address} - numero membri: ${club?.members_counter} - lista: 
      ${club?.members?.map((m) => `${m.name} - ${m.rank}`)}`;

  const getPageKeyword = () =>
    `${club?.name} | regione: ${club?.region} | provincia: ${
      club?.province
    } | ${club?.legal_address} | ${club?.fields_address} | numero membri: ${club?.members_counter} |
      ${club?.members?.map((m) => `${m.name} - ${m.rank}`)} |`;

  const renderContent = () => {
    const n = isCrawler() ? club?.members?.length : 5;
    const m = isCrawler() ? club?.competitions?.length : 5;
    return (
      <>
        <ClubHeader {...club} followable_type={'club'} loading={loading} />
        <div id='content' className='mt-2 flex flex-col gap-2 lg:flex-row'>
          <div className='min-w-0 lg:min-w-80 lg:basis-1/4'>
            <div className='flex flex-col gap-3'>
              <ClubBasicInfo loading={loading} {...club} />
              <ClubMembers
                id={club?.id}
                listName={'Maestri'}
                loading={loading}
                clubMembersList={club?.teachers}
                members_counter={club?.teachers?.length}
              />
            </div>
          </div>
          <div className='lg:basis-3/4'>
            <div className='flex flex-col gap-3'>
              <ClubBaseStatistics loading={loading} {...club} />
              <ClubRecentCompetitions
                loading={loading}
                id={club?.id}
                competitions={club?.competitions?.slice(0, m)}
                title='Ultime Competizioni'
              />
              <ClubRecentCompetitions
                loading={loading}
                id={club?.id}
                title='Ultime gare di Competizioni a squadre'
                draws={club?.draws?.slice(0, m)}
              />
              <ClubMembers
                id={club?.id}
                listName={'Tesserati'}
                loading={loading}
                clubMembersList={club?.members?.slice(0, n)}
                members_counter={club?.members?.length}
                twoColumns={true}
              />
            </div>
          </div>
        </div>
      </>
    );
  };
  let pageTitle = 'Profilo del circolo';

  let content = renderContent();
  let pageKeywords;
  let pageDescription = '';

  if (!loading) {
    if (!error && club) {
      pageTitle = `Circolo: ${club?.name}`;
      pageKeywords = getPageKeyword();
      pageDescription = getPageDescription();
    } else {
      content = (
        <div className='flex justify-center'>
          <ErrorBox
            errorType='Circolo non trovato'
            errorTitle='Qualcosa è andato storto nel caricamento di questo circolo'
            errorMessage='Prova più tardi. Se avrai nuovamente problemi, scrivici.'
          />
        </div>
      );
    }
  }

  return (
    <Page title={pageTitle} description={pageDescription || pageTitle} keywords={pageKeywords} showAds={true}>
      <AdKaoraBanner slot={AdSlot.ARTICLE_TOP} />
      <div className='mt-3'>{content}</div>
      <AdKaoraBanner slot={AdSlot.ARTICLE_BOTTOM} />
    </Page>
  );
};

export default ClubPage;
